import { CountrySelector } from '@components/country-selector';
import { GroupRadioSelector } from '@components/group-radio-selector';
import { Input } from '@components/input';
import { InputBankNumber } from '@components/input-bank-number';
import { InputCheckbox } from '@components/input-checkbox';
import { InputGender } from '@components/input-gender';
import { InputMultiEmail } from '@components/input-multi-email';
import { InputPhone } from '@components/input-phone';
import { InputRadio } from '@components/input-radio';
import { InputUrlSimple } from '@components/input-url-simple';
import { InputVatNumber } from '@components/input-vat-number';
import { SelectWithOptions } from '@components/select';
import { SimpleDateInput } from '@components/simple-date-input';
import { Countries } from '@constants/countries.type';
import { type TFunction } from 'i18next';

import { FIELD_IBAN } from '../constants';
import { DataType, DynamicInputFields } from '../dynamic-input-fields.type';

export const getComponentFieldBy = ({
  fieldName,
  venueIsoCode,
  options,
  countries,
  t,
}: {
  fieldName: DataType;
  venueIsoCode?: string;
  options?: { label: string; value: string }[];
  countries?: Countries;
  t?: TFunction;
}) => {
  const fields: DynamicInputFields = {
    gender: {
      name: InputGender,
      extraProps: {
        selectFontLight: true,
      },
    },
    date: {
      name: SimpleDateInput,
      extraProps: {},
    },
    email: {
      name: Input,
      extraProps: {},
    },
    plainText: {
      name: Input,
      extraProps: {},
    },
    text: {
      name: Input,
      extraProps: {},
    },
    radio: {
      name: InputRadio,
      extraProps: {},
    },
    groupRadio: {
      name: GroupRadioSelector,
      extraProps: {
        containerClassName: 'flex-1 p-6 border bg-primary rounded-lg',
        options: options ?? [],
      },
    },
    checkbox: {
      name: InputCheckbox,
      extraProps: {},
    },
    list: {
      name: SelectWithOptions,
      extraProps: { selectFontLight: true, options: options ?? [] },
    },
    numericlist: {
      name: SelectWithOptions,
      extraProps: { selectFontLight: true, options: options ?? [] },
    },
    iban: {
      name: InputBankNumber,
      extraProps: { type: FIELD_IBAN },
    },
    url: {
      name: InputUrlSimple,
      extraProps: {},
    },
    instagram: {
      name: InputUrlSimple,
      extraProps: {},
    },
  };
  if (t) {
    fields.multiEmail = {
      name: InputMultiEmail,
      extraProps: {
        helperText: t('companySettings:multiEmailHintText'),
        optional: true,
        placeholder: t('companySettings:multiEmailPlaceholder'),
      },
    };
    fields.vat = {
      name: InputVatNumber,
      extraProps: {
        countryLabel: t('companySettings:countryCodeLabel'),
        vatLabel: t('companySettings:vatNumberLabel'),
        showWrapperLabel: false,
        showWrapperError: false,
      },
    };
  }
  fields.numeric = {
    name: InputPhone,
    extraProps: {
      showDial: false,
      initialCountry: venueIsoCode ?? '',
      selectFontLight: true,
    },
  };
  fields.country = {
    name: CountrySelector,
    extraProps: {
      showDial: false,
      showSelectedLabel: true,
      initialCountry: venueIsoCode ?? '',
      selectFontLight: true,
      ...(countries && { countries }),
    },
  };

  return fields[fieldName];
};
